import * as React from "react";
import { PropsWithChildren } from "react";
import { useAppContext } from "../../Contexts/AppContext";
import { PopupBody } from "../../Popups/Popup";
import "./WidgetPopup.scss";

interface IWidgetPopupProps {
    hidden?: boolean;
    displayLayerIds?: string[];
}

export const WidgetPopup = (props: PropsWithChildren<IWidgetPopupProps>): JSX.Element => {
    const { isMobile } = useAppContext();

    return !props.hidden ? (
        <div className="shadow" id="widget-popup">
            <PopupBody isMobile={isMobile}>{props.children ? props.children : null}</PopupBody>
        </div>
    ) : null;
};
